import React from "react";
import { Link } from "@heroui/react";
import { FaTelegramPlane } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import logo from "../../../src/assets/img/MASH Primary logo White-aligned only text.svg";
import logoSolana from "../../../src/assets/img/solanaLogo.svg";

export default function Footer() {
  return (
    <footer className="w-full px-6 lg:px-60 py-12 bg-transparent text-white">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8">
        {/* Left column */}
        <div className="flex flex-col items-start space-y-4">
          <img src={logo} alt="Logo" className="h-6 lg:h-8 w-auto" />

          <div className="flex items-center gap-2">
            <span className="text-s text-gray-300">gas free on</span>
            <img src={logoSolana} alt="LogoSolana" className="h-3 w-auto" />
          </div>
        </div>

        {/* Right column */}
        <div className="flex flex-col items-start lg:items-end space-y-6">
          <Link
            href="https://docs.mash.fun/s/home"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-gray-300 transition"
          >
            Docs
          </Link>
          <Link
            href="https://x.com/mashdotfun"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-gray-300 transition flex items-center gap-2"
          >
            <FaXTwitter size={18} />
            <span className="sr-only">X</span>
          </Link>
          <Link
            href="https://t.me/mashdotfun"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-gray-300 transition flex items-center gap-2"
          >
            <FaTelegramPlane size={18} />
            <span className="sr-only">Telegram</span>
          </Link>
        </div>
      </div>
    </footer>
  );
}
